import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-tabler icon-tabler-refresh\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" id=\"refresh\"><path d=\"M0 0h24v24H0z\" stroke=\"none\" /><path d=\"M20 11A8.1 8.1 0 0 0 4.5 9M4 4v5h5M4 13a8.1 8.1 0 0 0 15.5 2m.5 5v-5h-5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol